<template>
  <nav
    class="ArticleNav"
    :class="{'is-sticky': isSticky}"
  >
    <ul class="ArticleNav__list global-wrapper">
      <li
        v-for="(link, index) in links"
        :key="index"
        class="ArticleNav__list-item"
      >
        <VisionLink
          :to="resolveLocalePath(link.slug)"
          class="ArticleNav__link t-h3"
          :class="{'t-gradient is-active': $route.path === resolveLocalePath(link.slug)}"
        >
          {{ link.title }}
        </VisionLink>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'ArticleNavigation',

  props: {
    links: {
      type: Array,
      required: true
    }
  },

  setup () {
    const { resolveLocalePath } = useUrlBuilder()

    return { resolveLocalePath }
  },

  data: () => ({
    isSticky: false,
    observer: null
  }),

  mounted () {
    this.$nextTick(() => this.setupStickyDetection())
  },

  unmounted () {
    if (this.observer) this.observer.disconnect()
  },

  methods: {
    setupStickyDetection () {
      this.observer = new IntersectionObserver(
        ([e]) => {
          this.isSticky = e.intersectionRatio < 1
        },
        { threshold: [1] }
      )

      const navBarEl = document.querySelector('.ArticleNav')
      this.observer.observe(navBarEl)
    }
  }
}
</script>

<style lang="postcss">
.ArticleNav {
  @apply sticky bg-white z-10 border-b border-solid border-grey border-opacity-0;

  --nav-height: 60px;
  --nav-bottom-margin: 20px;

  @screen sm {
    --nav-height: 72px;
    --nav-bottom-margin: 40px;
  }

  top: -1px;
  height: var(--nav-height);
  margin-bottom: var(--nav-bottom-margin);
  transition: border 0.15s ease;

  &.is-sticky {
    @apply border-opacity-100;

    transition-duration: 0.25s;
  }
}

.ArticleNav__list {
  @apply flex h-full items-center xsMax:justify-between overflow-x-scroll;

  &::-webkit-scrollbar {
    height: 0;
  }
}

.ArticleNav__list-item {
  &:not(:first-of-type) {
    @apply ml-xs sm:ml-sm;
  }
}

.ArticleNav__link {
  @apply block whitespace-nowrap;

  padding-top: 6px;

  &:not(.is-active) {
    @apply opacity-2 text-off-black transition-opacity;
  }

  &:hover:not(.is-active) {
    @apply opacity-70;
  }
}
</style>
